import { supabase } from "./supabaseClient"

const SERVER = process.env.REACT_APP_ENV === "production" ? "api" : "staging"

// Get the current authenticated admin's ID from Supabase
async function getAdminId() {
  const {
    data: { user },
  } = await supabase.auth.getUser()
  return user?.id
}

// Generic POST helper with optional token header
async function postAPI(endpoint, body, useAuth = true) {
  const headers = { "Content-Type": "application/json" }

  if (useAuth) {
    const token = localStorage.getItem("token")
    if (token) {
      headers["Authorization"] = `Bearer ${token}`
    }
  }

  const res = await fetch(`https://${SERVER}.readabled.com${endpoint}`, {
    method: "POST",
    headers,
    body: JSON.stringify(body),
  })

  if (!res.ok) {
    if (res.status === 500) {
      const errorText = await res.text()
      const encodedMessage = encodeURIComponent(errorText)
      window.location.href = `/auth/error?message=${encodedMessage}`
      return
    }
    const error = await res.text()
    throw new Error(`Request failed: ${res.status} ${error}`)
  }

  return res.json()
}

// API: Admin login (no token required)
export async function loginAdmin(adminEmail) {
  return postAPI("/api/adminLogin", { adminEmail }, false)
}

// API: List all users of an admin
export async function fetchUsersOfAdmin() {
  const adminId = await getAdminId()
  return postAPI("/admin/listUsersOfAdmin", { adminId })
}

// API: Get details for a specific user
export async function fetchUserDetails(userId) {
  return postAPI("/admin/fetchUserDetailsofAdmin", { userIdofAdmin: userId })
}

// API: Get user details by language
export async function fetchUserLanguageDetails(userId, language) {
  return postAPI("/admin/fetchUserDetailsByLanguageOfAdmin", {
    userIdofAdmin: userId,
    language,
  })
}

// API: Send magic login link to user
export async function sendMagicLinkToUser(userEmail) {
  return postAPI("/admin/sendMagicLinkToUser", { userEmail })
}
